(function () {
  var CARRY_BOX_VARIANT_ID = window.__dsCarryBoxVariantId ? parseInt(window.__dsCarryBoxVariantId, 10) : null;
  var BUILDER_URL = window.__dsBuilderPageUrl || "/pages/discovery-set";
  var BOX_IMAGE = window.__dsCarryBoxImage || "";
  var SET_SIZE = 4;

  if (!CARRY_BOX_VARIANT_ID) return;

  var syncing = false;
  var pendingResync = false;

  function get10mlQty(cart) {
    var qty = 0;
    cart.items.forEach(function (item) {
      if (item.variant_id === CARRY_BOX_VARIANT_ID) return;
      var title = (item.variant_title || "").toUpperCase();
      if (title.indexOf("10ML") !== -1) qty += item.quantity;
    });
    return qty;
  }

  function findCarryBoxLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === CARRY_BOX_VARIANT_ID) return cart.items[i];
    }
    return null;
  }

  // The Build Your Own Discovery Set page already has its own progress UI
  // built into the page itself, so the sitewide bar would be redundant
  // there — only show it on every other page (product pages, cart,
  // collections, etc.).
  function isBuilderPage() {
    return !!document.querySelector(".ds-builder");
  }

  function ensureBar() {
    var bar = document.getElementById("ds-sticky-bar");
    if (bar) return bar;
    bar = document.createElement("div");
    bar.id = "ds-sticky-bar";
    bar.className = "ds-sticky-bar is-hidden";
    bar.innerHTML =
      '<div class="ds-sticky-bar__inner">' +
      (BOX_IMAGE ? '<span class="ds-sticky-bar__icon"><img src="' + BOX_IMAGE + '" alt="" /></span>' : "") +
      '<div class="ds-sticky-bar__body">' +
      '<p class="ds-sticky-bar__headline"></p>' +
      '<div class="ds-sticky-bar__track"><div class="ds-sticky-bar__fill"></div></div>' +
      "</div>" +
      '<a class="ds-sticky-bar__cta" href="' +
      BUILDER_URL +
      '">See Full 10ML Collection →</a>' +
      "</div>";
    document.body.appendChild(bar);
    return bar;
  }

  // Sitewide-only-on-cart gate: the CTA bar itself should only ever be
  // visible on the cart page (next to the free-shipping progress bar) --
  // not on product pages, collections, home, etc. The background cart-sync
  // (auto add/remove of the free carry box) and the carry-box-card-hiding
  // logic below still need to run everywhere, so this only gates the UI.
  function isCartPage() {
    return window.location.pathname.replace(/\/$/, "") === "/cart";
  }

  function updateBar(qty) {
    var existing = document.getElementById("ds-sticky-bar");

    if (isBuilderPage() || !isCartPage()) {
      if (existing) existing.classList.add("is-hidden");
      return;
    }

    if (qty === 0) {
      if (existing) existing.classList.add("is-hidden");
      return;
    }

    var bar = ensureBar();
    var headline = bar.querySelector(".ds-sticky-bar__headline");
    var fill = bar.querySelector(".ds-sticky-bar__fill");
    var remainder = qty % SET_SIZE;
    var boxes = Math.floor(qty / SET_SIZE);

    bar.classList.remove("is-hidden");
    // Freshly shown (e.g. this is the first item added, or the page just
    // loaded) should start in the visible position, not mid-collapse from a
    // stale scroll state.
    bar.classList.remove("is-collapsed");
    fill.style.width = (remainder / SET_SIZE) * 100 + "%";

    var boxesLabel = boxes === 1 ? "1 free carry box" : boxes + " free carry boxes";

    if (remainder === 0) {
      headline.textContent = "You've earned " + boxesLabel + "! Keep building to earn more.";
      bar.classList.add("is-unlocked");
    } else {
      var needed = SET_SIZE - remainder;
      headline.textContent =
        boxes > 0
          ? boxesLabel + " earned — add " + needed + " more 10ML to unlock another free carry box!"
          : "Add " + needed + " more 10ML to unlock a free carry box!";
      bar.classList.remove("is-unlocked");
    }
  }

  // Hide the bar while the customer is actively scrolling down (it's had
  // its moment, no need to keep covering content), and bring it back as
  // soon as they scroll up or reach the top of the page — so it's fixed to
  // the bottom of the viewport but not permanently, unavoidably sticky.
  var lastScrollY = window.scrollY || window.pageYOffset || 0;
  var scrollTicking = false;
  var SCROLL_DELTA_THRESHOLD = 6;

  function handleScroll() {
    var bar = document.getElementById("ds-sticky-bar");
    var currentY = window.scrollY || window.pageYOffset || 0;

    if (!bar || bar.classList.contains("is-hidden")) {
      lastScrollY = currentY;
      return;
    }

    if (currentY <= 0) {
      bar.classList.remove("is-collapsed");
      lastScrollY = currentY;
      return;
    }

    var delta = currentY - lastScrollY;

    if (delta > SCROLL_DELTA_THRESHOLD) {
      bar.classList.add("is-collapsed");
      lastScrollY = currentY;
    } else if (delta < -SCROLL_DELTA_THRESHOLD) {
      bar.classList.remove("is-collapsed");
      lastScrollY = currentY;
    }
  }

  window.addEventListener(
    "scroll",
    function () {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        handleScroll();
        scrollTicking = false;
      });
    },
    { passive: true }
  );

  function recalc() {
    if (syncing) {
      pendingResync = true;
      return;
    }
    syncing = true;

    fetch("/cart.js", { headers: { "Content-Type": "application/json" } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var qty = get10mlQty(cart);
        updateBar(qty);

        var required = Math.floor(qty / SET_SIZE);
        var line = findCarryBoxLine(cart);
        var current = line ? line.quantity : 0;

        if (current === required) {
          return null;
        }

        var body = line
          ? { id: line.key, quantity: required }
          : { id: CARRY_BOX_VARIANT_ID, quantity: required, properties: { _free_gift: "carry_box" } };
        var endpoint = line ? "/cart/change.js" : "/cart/add.js";

        return fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });
      })
      .catch(function () {
        /* silent - non-critical background sync */
      })
      .then(function () {
        syncing = false;
        if (pendingResync) {
          pendingResync = false;
          recalc();
        }
      });
  }

  // Detect cart mutations from anywhere on the site (product pages, cart drawer,
  // cart page, quick add, or the discovery set builder) by wrapping fetch.
  var originalFetch = window.fetch;
  window.fetch = function () {
    var target = arguments[0];
    var url = (target && target.url) || target || "";
    var isCartMutation = typeof url === "string" && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    return originalFetch.apply(this, arguments).then(function (response) {
      if (isCartMutation) {
        setTimeout(recalc, 50);
      }
      return response;
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", recalc);
  } else {
    recalc();
  }

  // The carry box is a free gift, not something customers should be able to
  // browse or add on their own. It's UNLISTED (excluded from search/collections)
  // and uses a template with no buy form, but quick-add buttons on product
  // grid cards bypass the product page entirely — so also hide any card that
  // links to it, anywhere on the site (search results, collections, related
  // products, home page, etc.).
  var CARRY_BOX_HANDLE = "marcais-carry-box";

  function hideCarryBoxCards() {
    document.querySelectorAll('a[href*="/products/' + CARRY_BOX_HANDLE + '"]').forEach(function (link) {
      if (link.dataset.dsHidden === "1") return;
      link.dataset.dsHidden = "1";

      // Never touch the carry box's own thumbnail inside the cart drawer or
      // cart page -- that's the free gift's legitimate line-item image, not
      // a browsable product grid card. Matching it here (via the generic
      // `link.parentElement` fallback this used to have) was hiding the
      // carry box's picture in the cart.
      if (link.closest("tr, .cart-items, .cart-drawer")) return;

      var item = link.closest("li") || link.closest("product-card") || link.closest('[class*="card-wrapper"]');
      if (item) {
        item.style.display = "none";
        item.setAttribute("aria-hidden", "true");
      }
    });
  }

  hideCarryBoxCards();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hideCarryBoxCards);
  }

  // On the cart page (and cart drawer, which shares the same markup), the
  // carry box still shows up as a normal line item with +/- quantity buttons
  // and a remove button. It's a free gift added automatically per complete
  // set of 4 — customers shouldn't be able to manually bump its quantity up
  // or down. Replace those controls with a static label that also states
  // exactly how many free carry boxes have been earned, since the line
  // item quantity IS that count.
  function lockCarryBoxCartRow() {
    var rows = document.querySelectorAll('tr[data-key^="' + CARRY_BOX_VARIANT_ID + ':"]');
    rows.forEach(function (row) {
      if (row.dataset.dsLocked === "1") return;
      row.dataset.dsLocked = "1";

      var qtyCell = row.querySelector(".cart-items__quantity");
      if (qtyCell) {
        var qtyInput = qtyCell.querySelector("input");
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : NaN;
        if (isNaN(qty) || qty < 1) qty = 1;
        var label = qty > 1 ? qty + " Free Carry Boxes" : "Free Carry Box (Gift)";
        qtyCell.innerHTML = '<span class="ds-cart-free-gift">' + label + "</span>";
      }

      var removeBtn = row.querySelector(".cart-items__remove");
      if (removeBtn) {
        removeBtn.style.display = "none";
      }
    });
  }

  lockCarryBoxCartRow();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", lockCarryBoxCartRow);
  }

  // Both functions above run on every DOM mutation anywhere on the page so
  // the carry box stays hidden/locked even after cart drawer opens, section
  // re-renders, etc. Cart interactions (opening the drawer, adding an item,
  // the cart icon's own update animation) can fire many DOM mutations in a
  // single burst, and running two document-wide querySelectorAll passes for
  // every single one of them competes with that animation for main-thread
  // time — coalesce bursts down to one pass per animation frame instead.
  if (window.MutationObserver) {
    var observerScheduled = false;
    var cardObserver = new MutationObserver(function () {
      if (observerScheduled) return;
      observerScheduled = true;
      requestAnimationFrame(function () {
        observerScheduled = false;
        hideCarryBoxCards();
        lockCarryBoxCartRow();
      });
    });
    cardObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
